
window.openModal = function() {
  $('.modal').addClass('is-active');
  $('html').addClass('is-clipped');
};

$(document).ready(function(){
  $(".navbar-burger").click(function() {
    $(".navbar-menu").toggleClass("is-active");
  });

  $('.top-banners').owlCarousel({
      items: 1,
      loop: true,
      margin: 10,
      autoplay: true,
      autoplayTimeout: 2000,
      autoplayHoverPause: true,
      // responsive: {
      //   768 : {
      //     items: 1,
      //   }
      // }
  });

  $('#partners').owlCarousel({
      items: 3,
      loop: true,
      margin: 10,
      autoplay: true,
      autoplayTimeout: 2000,
      autoplayHoverPause: true,
      responsive: {
        768 : {
          items: 5,
        }
      }
  });

  function showFlash(text){
    //TODO replace with bootstrap alert
    alert(text);
  }

  var modalOpenning = false;
  var modalOpenned = false;
  function toggleModalClasses() {
    var modal = $('.modal');
    modal.toggleClass('is-active');
    $('html').toggleClass('is-clipped');
    modalOpenning = !modalOpenning;
    modalOpenned = true;
  };

  function openModal() {
    $('.modal').addClass('is-active');
    $('html').addClass('is-clipped');
  };

  function closeModal() {
    $('.modal').removeClass('is-active');
    $('html').removeClass('is-clipped');
    modalOpenning = false;
  };

  function showThanksState($form) {
    var name = ($form.find('input[name="contact[name]"]').val() || '').trim();
    var $modal = $form.closest('.modal');
    if (!$modal.length) {
      // Sidebar/footer form — fall back to alert and open modal in thanks state
      $modal = $('.modal').first();
      openModal();
    }
    if (name) {
      $modal.find('.modal-thanks-greeting').text('Cảm ơn ' + name + '!');
    }
    $modal.find('.modal-form-state').hide();
    $modal.find('.modal-thanks-state').show();

    if (window.dataLayer) {
      window.dataLayer.push({ event: 'contact_form_submitted' });
    }
  }

  function resetModalState() {
    var $modal = $('.modal');
    $modal.find('.modal-thanks-state').hide();
    $modal.find('.modal-form-state').show();
    $modal.find('form.phone-call-register')[0] && $modal.find('form.phone-call-register')[0].reset();
  }

  $(".phone-call-register").on("ajax:success", function(event) {
    showThanksState($(this));
  }).on("ajax:error", function(event) {
    showFlash('Xin lỗi có lỗi đã xảy ra. Xin bạn hãy nhắn tin qua facebook hoặc zalo.');
  });

  $('.open-modal').click(toggleModalClasses);
  $('.close-modal').click(function() {
    toggleModalClasses();
    setTimeout(resetModalState, 300);
  });
  $('.modal-background').click(function() {
    closeModal();
    setTimeout(resetModalState, 300);
  });

  var footerHeight = $('.footer').height();
  // Pages where the scroll-to-bottom auto-popup should NOT trigger
  // (already have their own contextual CTAs, popup feels intrusive).
  var noAutoPopupPaths = ["/tuyen-dung", "/uoc-tinh-phi-bao-hiem", "/lien-he"];
  var skipAutoPopup = noAutoPopupPaths.indexOf(location.pathname) >= 0;
  $(window).on("scroll", function() {
    if (!skipAutoPopup && !modalOpenned && (window.innerHeight + window.scrollY + footerHeight) >= document.body.offsetHeight) {
      toggleModalClasses();
    }
  })
})
